import { render, staticRenderFns } from "./ColorPalette.vue?vue&type=template&id=37ab8f94&scoped=true&"
import script from "./ColorPalette.vue?vue&type=script&lang=js&"
export * from "./ColorPalette.vue?vue&type=script&lang=js&"
import style0 from "./ColorPalette.vue?vue&type=style&index=0&id=37ab8f94&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ab8f94",
  null
  
)

export default component.exports